<template>
  <div>
    <div class="container pt-0">
      <div class="row">
        <div v-if="isClinius" class="col" :class="{ 'text-center': isClinius }">
          <h1 :class="{ 'fs-40': isClinius }">{{ $t("heading_booking") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div
                class="col-md-5 pr-lg-5 text-left"
                :class="{ 'border-right': !isMobile }"
              >
                <h2>{{ $t("your_appointment") }}</h2>
                <termin-zusammenfassung />
              </div>
              <div class="col-md-7 text-dark">
                <div class="row">
                  <div v-if="!gesendet" class="col-12 mt-md-5">
                    <div class="row" v-if="recallToken">
                      <div class="col-12 mb-3">
                        {{ $t("recall.termin_von_praxis_abgesagt") }}
                      </div>
                    </div>
                    <div class="row" v-else-if="moveToken">
                      <div class="col-12 mb-3">
                        {{ $t("recall.behandlungsplan") }}
                      </div>
                    </div>
                    <div v-if="!rueckruf" class="row">
                      <div class="col-12 mb-3">
                        {{ $t("recall.rueckruf_click_1") }}
                      </div>
                      <div class="col-sm-12 col-md-6 offset-md-3 mb-3">
                        <button
                          class="btn btn-primary w-100"
                          @click="rueckruf = true"
                        >
                          {{ $t("recall.rueckruf_click_2") }}
                        </button>
                      </div>
                    </div>
                    <div v-if="rueckruf" class="row">
                      <div class="col-12 mb-3 text-dark">
                        {{ $tc("recall.nummer_anzeige", 1,{ nummer: nummer }) }}
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label>{{
                            $t("recall.wann_erreichbar_label")
                          }}</label>
                          <textarea
                            v-model="erreichbarkeit"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 offset-md-3">
                        <button class="btn btn-primary w-100" @click="send">
                          {{ $t("actions.send") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-12">
                    <div class="text-center">
                      <div
                        class="fs-40 mt-5"
                        :class="{ 'text-primary': isClinius }"
                      >
                        <font-awesome-icon v-if="success" icon="check" />
                        <font-awesome-icon v-if="!success" icon="times" />
                      </div>
                      <div
                        ref="textConfirm"
                        class="text-confirm-head mt-3"
                        :class="{ 'text-primary': isClinius }"
                      >
                        {{
                          this.success
                            ? $t("recall.gebucht")
                            : $t("recall.nicht_gebucht")
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TerminZusammenfassung from "@/components/TerminZusammenfassung";
  import { Api } from "../api";

  export default {
    name: "RueckrufBitte",
    components: {
      TerminZusammenfassung,
    },
    data() {
      return {
        recallToken: this.$route.query.recall,
        moveToken: this.$route.query.move,
        erreichbarkeit: null,
        rueckruf: false,
        gesendet: false,
        success: null,
      };
    },
    async created() {
      if (this.recallToken)
        await this.$store.dispatch("loadActualTermin", [this.recallToken]);
    },
    computed: {
      nummer() {
        return this.$store.state.termin.patient?.mobilenumber;
      },
    },
    methods: {
      async send() {
        let json = {
          token: this.recallToken || this.moveToken,
          Freitext: this.erreichbarkeit
        };

        try {
          await Api.post("/book/recall/", json);
          this.success = true;
        } catch {
          this.success = false;
        } finally {
          this.gesendet = true;
        }
      },
    },
  };
</script>

<style>
</style>
